import { useDebugValue, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { showSwalError, showSwalSuccess } from "../../utils/swal";
import DatePicker from "react-multi-date-picker";
import { FaPlusCircle } from "react-icons/fa";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/prime.css";
import CreatableSelect from "react-select/creatable";
import $ from "jquery";
import useAxios from "../../services/useAxios.tsx";

export default function Modals({
  SelectedUserInformation,
  updateFilteredUsers,
  users,
  EditUser,
  changeStatus,
  chosenPeople,
  Update,
  Tab,
  Access,
  Citys,
  UserAccess,
  setUserAccess,
  FirstAccess,
  Labels,
  setUpdater,
  Updater,
  SendMessage,
}) {
  const { execute: Delete_UserRoll } = useAxios("test/Delete_UserRoll");
  const { execute: Insert_UserRoll } = useAxios("test/Insert_UserRoll");
  const { execute: save_TagLink } = useAxios("test/save_TagLink");
  const { execute: Delete_TagLink } = useAxios("test/Delete_TagLink");

  const [State, setState] = useState(2);
  const [AddTags, setAddTags] = useState([]);
  const [DelTags, setDelTags] = useState([]);
  const [flag, setFlag] = useState(true);
  const [Text, setText] = useState("");
  const [img, setimg] = useState("");
  const [key, setkey] = useState(0);
  const [keyDel, setkeyDel] = useState(0);
  const [SendMg, setSendMg] = useState({
    msgtxt: "",
    needsms: false,
    needemail: false,
  });

  function UpdateAccess(value, id) {
    let array = [...UserAccess];
    if (value) {
      setUserAccess([...UserAccess, id]);
    } else {
      array.splice(array.indexOf(id), 1);
      setUserAccess(array);
    }
  }

  const sendAccessLevel = (id) => {
    let wrong = true;
    FirstAccess.map((item) => {
      if (!UserAccess.includes(item)) {
        let form = new FormData();
        form.append("conditions", `value/=/${item}@@uid/=/${id}`);
        Delete_UserRoll(form)
          .then(({ data }) => {
            if (!data.status && wrong) {
              wrong = false;
              Swal.fire(
                "مشکلی در ویرایش سطح دسترسی کاربر پیش آمده است",
                "",
                "warning"
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });

    UserAccess.map((item) => {
      if (!FirstAccess.includes(item)) {
        let form = new FormData();
        form.append("uid", `${id}`);
        form.append("value", `${item}`);
        Insert_UserRoll(form)
          .then(({ data }) => {
            if (!data.status && wrong) {
              wrong = false;
              Swal.fire(
                "مشکلی در ویرایش سطح دسترسی کاربر پیش آمده است",
                "",
                "warning"
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
    if (wrong) {
      showSwalSuccess("ویرایش انجام شد");
    }
  };

  const SendUsersTag = (Add, Del, SelectPeople) => {
    let form = new FormData();
    let str = "";
    Add.map((item, index) => {
      if (index == Add.length - 1) {
        str += [item.label, parseInt(item.value)].toString();
      } else {
        str += [item.label, parseInt(item.value)].toString() + "@@";
      }
    });
    form.append("tags", `${str}`);

    let wrong = true;
    SelectPeople.map((value) => {
      if (str != "") {
        form.delete("uid");
        form.append("uid", `${value[0]}`);
        save_TagLink(form)
          .then(({ data }) => {
            let Data = data.data;
            let Datakey = Object.keys(data.data);
            Datakey.map((item) => {
              if (
                (!Data[item].status == "ok" || !Data[item].status == true) &&
                wrong
              ) {
                wrong = false;
                showSwalError(
                  "مشکلی در عملیات تعدادی از برچسب ها  به وجود آمده"
                );
              }
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
      Del.map((item) => {
        let form = new FormData();
        form.append(
          "conditions",
          `TagId/=/${item.value}@@linkId/=/${value[0]}@@type/=/1`
        );
        Delete_TagLink(form)
          .then(({ data }) => {
            if (!data.status && wrong) {
              wrong = false;
              showSwalError("مشکلی در عملیات تعدادی از برچسب ها  به وجود آمده");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
      if (wrong) {
        showSwalSuccess("عملیات با موفقیت انجام شد");
      }
    });

    setUpdater(!Updater);
  };

  useEffect(() => {
    document
      .getElementById("edit-user")
      .addEventListener("hidden.bs.modal", () => {
        setimg("");
      });
  }, []);

  return (
    <>
      <div
        className="modal fade"
        id="edit-user"
        tabIndex={-1}
        aria-labelledby="edit-userLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="edit-userLabel">
                ویرایش کاربر
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="edit-user-container">
                <form id="edit-user-form-data">
                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="profile-pic">
                      <div className="profile-pic position-relative">
                        <input
                          className="d-none"
                          type="file"
                          accept="image/*"
                          id="ProfilePic"
                          onChange={(e) => {
                            EditUser({
                              ...SelectedUserInformation,
                              ["profile_pic_file_path"]: e.target.files[0],
                            });
                            setimg(URL.createObjectURL(e.target.files[0]));
                          }}
                        />
                        <img
                          src={
                            img == ""
                              ? `${
                                  "http://irancovercrmb.tatdemo.ir/" +
                                  SelectedUserInformation.profile_pic_file_path
                                }`
                              : `${img}`
                          }
                          alt=""
                          style={{
                            width: "80px",
                            borderRadius: "50%",
                            height: "80px",
                            overflow: "hidden",
                          }}
                        />
                        <label
                          htmlFor="ProfilePic"
                          className="position-absolute text-dark"
                          style={{ right: "3px", top: "-10px" }}
                        >
                          <FaPlusCircle />
                        </label>
                      </div>
                    </label>
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="gender-edit-user" className="title">
                      نوع
                    </label>

                    <select
                      className="form-select"
                      value={SelectedUserInformation.type}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["type"]: e.target.value,
                        })
                      }
                      name="type"
                      id="type-edit-user"
                    >
                      <option value={1}>پرسنل</option>
                      <option value={2}>مشتری</option>
                    </select>
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="title" htmlFor="name-edit-user">
                      نام{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name-edit-user"
                      value={SelectedUserInformation.fname}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["fname"]: e.target.value,
                        })
                      }
                      name="fname"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="title" htmlFor="fullname-edit-user">
                      نام خانوادگی
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={SelectedUserInformation.lname}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["lname"]: e.target.value,
                        })
                      }
                      name="lname"
                      id="fullname-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label
                      className="title"
                      htmlFor="usefulHours-name-edit-user"
                    >
                      ساعت مفید
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={SelectedUserInformation.usefulHours}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["usefulHours"]: e.target.value,
                        })
                      }
                      name="usefulHours"
                      id="usefulHours-name-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label className="title" htmlFor="national-code-edit-user">
                      کد ملی
                    </label>
                    <input
                      type="number"
                      className="form-control text-start"
                      value={SelectedUserInformation.codemeli}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["codemeli"]: e.target.value,
                        })
                      }
                      name="codemeli"
                      id="national-code-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="address-edit-user" className="title">
                      آدرس{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={SelectedUserInformation.address}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["address"]: e.target.value,
                        })
                      }
                      name="address"
                      id="address-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="tell-edit-user" className="title">
                      تلفن همراه{" "}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={SelectedUserInformation.mobile}
                      onChange={(e) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["mobile"]: e.target.value,
                        })
                      }
                      name="tell"
                      id="tell-edit-user"
                    />
                  </div>

                  <div className="edit-user-item d-flex justify-content-between filter-modal">
                    <label htmlFor="birthdayts" className="title">
                      تاریخ تولد:
                    </label>

                    <DatePicker
                      id="birthdayts"
                      className="rmdp-prime w-100"
                      showOtherDays
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      name="birthdayts"
                      value={parseInt(SelectedUserInformation.bdtm)}
                      onChange={(dateObjects) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["bdday"]: dateObjects.day,
                          ["bdmonth"]: dateObjects.month.number,
                          ["bdyear"]: dateObjects.year,
                          ["bdtm"]: dateObjects.unix,
                        })
                      }
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #cbc7c7",
                        borderRadius: "4px",
                      }}
                    />
                  </div>

                  {/* <div className="edit-user-item d-flex justify-content-between">
                    <label htmlFor="mtm" className="title">
                      تاریخ عضویت
                    </label>
                    <DatePicker
                      id="mtm"
                      className="rmdp-prime"
                      showOtherDays
                      calendar={persian}
                      locale={persian_fa}
                      onClose={() => ""}
                      value={SelectedUserInformation.mtm * 1000}
                      onChange={(dateObjects) =>
                        EditUser({
                          ...SelectedUserInformation,
                          ["mtm"]: dateObjects.unix,
                        })
                      }
                      style={{
                        backgroundColor: "white",
                        border: "1px solid #cbc7c7",
                        borderRadius: "4px",
                      }}
                      calendarPosition="bottom-right"
                      name="mtm"
                    />
                  </div> */}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Update(SelectedUserInformation);
                  setimg("");
                }}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="access-level"
        tabIndex={-1}
        aria-labelledby="edit-userLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="edit-userLabel">
                سطح دسترسی
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {Access.map((item, index) => (
                <div className="ms-3 d-flex align-items-center" key={item[0]}>
                  <input
                    checked={UserAccess.includes(item[0])}
                    type="checkbox"
                    className="form-check form-check-inline"
                    id={`Access${item[0]}`}
                    onChange={(e) => UpdateAccess(e.target.checked, item[0])}
                  />
                  <label
                    htmlFor={`Access${item[0]}`}
                    className="form-check-label "
                  >
                    {item[1]}
                  </label>
                </div>
              ))}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                onClick={() => {
                  sendAccessLevel(SelectedUserInformation.id);
                }}
                className="btn btn-primary"
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="send-message"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                ارسال پیام
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className=" ">
                <label htmlFor="send-message-input1">پیام:</label>
                <textarea
                  required
                  id="send-message-input1"
                  className="form-control ms-2 mb-2"
                  value={SendMg.msgtxt}
                  onChange={(e) =>
                    setSendMg({ ...SendMg, ["msgtxt"]: e.target.value })
                  }
                ></textarea>

                <input
                  type="checkbox"
                  className="mx-2 form-check-input"
                  id="Email-Check"
                  value={SendMg.needemail ? true : false}
                  onChange={(e) =>
                    setSendMg({
                      ...SendMg,
                      ["needemail"]: e.target.checked ? 1 : 0,
                    })
                  }
                />
                <label htmlFor="Email-Check" className="m-1">
                  ارسال ایمیل
                </label>
                <br />
                <input
                  type="checkbox"
                  className="mx-2 form-check-input"
                  id="SMS-Check"
                  value={SendMg.needsms ? true : false}
                  onChange={(e) =>
                    setSendMg({
                      ...SendMg,
                      ["needsms"]: e.target.checked ? 1 : 0,
                    })
                  }
                />
                <label htmlFor="SMS-Check" className="m-1">
                  ارسال پیامک
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                onClick={() =>
                  SendMessage(
                    SendMg,
                    chosenPeople.length == 0
                      ? [
                          [
                            SelectedUserInformation.id,
                            SelectedUserInformation.email,
                          ],
                        ]
                      : chosenPeople,
                    setSendMg
                  )
                }
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ارسال
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="toggle-status-modal"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                فعال / غیرفعال سازی کاربران{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="form-check form-switch ps-0">
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  فعال سازی کاربران:
                </label>
                <input
                  checked={State == 2 ? false : true}
                  className="form-check-input ms-1"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  style={{ float: "none" }}
                  onChange={(e) => setState(e.target.checked ? 1 : 2)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                data-bs-dismiss="modal"
                aria-label="Close"
                type="button"
                onClick={() => changeStatus(chosenPeople, State, Tab)}
                className="btn btn-primary"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="change-label"
        tabIndex={-1}
        aria-labelledby="send-messageLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="send-messageLabel">
                برچسب{" "}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center">
                <label htmlFor="add-label-input" style={{ width: "150px" }}>
                  افزودن برچسب:
                </label>

                <CreatableSelect
                  isMulti
                  placeholder={"انتخاب"}
                  options={Labels}
                  id="add-label-input"
                  className="text-dark group-change-label ms-2"
                  value={AddTags}
                  onChange={(e) => setAddTags(e)}
                />
              </div>
              <div className="d-flex align-items-center">
                <label
                  htmlFor="send-message-input me-2"
                  style={{ width: "150px" }}
                >
                  حذف برچسب:
                </label>

                <CreatableSelect
                  isMulti
                  placeholder={"انتخاب"}
                  options={Labels}
                  className="text-dark group-change-label ms-2"
                  isSearchable={false}
                  value={DelTags}
                  onChange={(e) => setDelTags(e)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                onClick={() => SendUsersTag(AddTags, DelTags, chosenPeople)}
                className="btn btn-primary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                ثبت
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
